module.exports = __webpack_public_path__ + "static/media/verification-code.c55abc05.svg";